import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import Store from 'store/store';
import { joinClasses } from 'utils/utils';
import Button from 'components/bolt/button/button';
import s from 'components/bolt/header/header.sss';

export default class Header extends BaseComp.default {

	triggerPersistentButton(path, label, sameWindow, e) {
		super.triggerPersistentButton(...arguments);
	}

	renderPersistentButton() {
		let base = super.renderPersistentButton();
		let audioSrc = this.props.appData?.pages?.phase2LandingPage?.data?.phoneRingAudioSrc;
		return [
			!!audioSrc && <audio class="phone-ring-audio" src={audioSrc} />
		].concat(base).filter(e => e);
	}

	renderHeaderLogo() {
		const headerLogo = this.props?.appData?.header?.powsterHeader?.logo;
		const headerLogoExclusions = (headerLogo?.pageExclusions || '').split(',')?.map(e => e.trim())?.filter(e => e);
		const headerLogoInclusions = (headerLogo?.pageInclusions || '').split(',')?.map(e => e.trim())?.filter(e => e);
		// const isDesktopSize = this.props?.client?.isDesktopSize;
		const activePage = Store.get().activePage;

		let hideHeaderLogo;
		if (headerLogoInclusions.length > 0) {
			hideHeaderLogo = !headerLogoInclusions.includes(activePage);
		} else {
			hideHeaderLogo = headerLogoExclusions.includes(activePage);
		}

		if (headerLogo) {
			return (
				<Button
					class={joinClasses(s.headerLogo, hideHeaderLogo && s.hide, !headerLogo.path && s.unclickable)}
					trigger={() => headerLogo.path && this.triggerPersistentButton(headerLogo.path, 'Logo', headerLogo.sameWindow)}
					key="headerLogo"
				>
					<img src={headerLogo.src} alt={headerLogo.alt} />
				</Button>
			);
		}
	}

}
